import { OverlayToaster, type Toaster, type ToastProps } from "@blueprintjs/core";

// Blueprint v6 made toaster creation async (React 18 strict mode requirement).
// We lazily initialize a single shared instance and queue toasts behind it.

let toasterPromise: Promise<Toaster> | null = null;

function getToaster(): Promise<Toaster> {
  if (!toasterPromise) {
    toasterPromise = OverlayToaster.createAsync({ position: "top" });
  }
  return toasterPromise;
}

/**
 * Show a Blueprint toast. Fire-and-forget — handles the async setup internally
 * so callers don't have to await.
 */
export function showToast(props: ToastProps): void {
  getToaster()
    .then((t) => t.show(props))
    .catch((err) => {
      // Toaster failed to mount. Last-resort fallback so messages aren't lost.
      // eslint-disable-next-line no-console
      console.warn("[toaster] failed to show toast", err, props);
    });
}
